var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 302.86 395.98" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "Asset 1"
    ),
    React.createElement(
      "g",
      { id: "Layer_2", "data-name": "Layer 2" },
      React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M191.56 98.5V28.93h31.33a12.21 12.21 0 0 0 12.17-12.18v-4.58A12.2 12.2 0 0 0 222.89 0H80a12.21 12.21 0 0 0-12.2 12.17v4.58A12.21 12.21 0 0 0 80 28.93h31.3V98.5a151.43 151.43 0 1 0 80.26 0zM203 160.66a21 21 0 1 1-21 21 21.23 21.23 0 0 1 21-21zm-62.25-22.07a20.16 20.16 0 1 1-20.17 20.16 20.43 20.43 0 0 1 20.17-20.16zm140.71 110a130 130 0 0 1-259.76 3.73 13.26 13.26 0 0 1-.37-3.09v-22.12a14.56 14.56 0 0 1 14.37-14.37 14.6 14.6 0 0 1 14.37 14.37v17.44h.19v19.52a14.37 14.37 0 0 0 28.74 0v-19.52h.2v-42.07a14.37 14.37 0 0 1 28.74 0v42.07h.28a14.36 14.36 0 0 0 28.56 0h.28v-17.44a14.37 14.37 0 0 1 28.74 0v17.44h.2V263a14.37 14.37 0 1 0 28.74 0v-18.45h.2v-5.12a14.37 14.37 0 1 1 28.74 0v5.12h.19v2.07a14.37 14.37 0 0 0 28.74 0v-2.07h.19V223a14.37 14.37 0 1 1 28.74 0v24.28c-.01.45-.04.89-.08 1.33z", id: "v1" })
    )
  );
});